module.exports = __webpack_public_path__ + "img/symbol_4.5820e90b.png";